<template>
    <div v-loading="loading" class="dp-body">
        <!-- <el-row :gutter="20">
            <el-col :span="7" class="item">
                <div v-for="item in dataList" :key="item.Id">
                    {{ item.CreateMoon }}
                </div>
            </el-col>
            <el-col :span="13" class="item-body">
                <div>
                </div>
            </el-col>
        </el-row> -->
        <el-tabs v-if="dataList.length > 0" tab-position="left" type="card" style="height: 100%;">
            <el-tab-pane v-for="(item,index) in dataList" :key="item.Id" :label="item.CreateMoon">
                <div slot="label" @click="sendHaveRead(item,index)">
                    {{ item.CreateMoon }}
                </div>
                <div class="item-body">
                    <div class="font-bold tab-font">
                    {{ item.CreateMoon }}账单
                    </div>
                    <div class="titiol">
                        账单费用所属{{ item.StartTime +"至"+ item.EndTime}}月账单入下图，点击图片后，可以查看大图，如若对账单有疑问，可联系车回佳财务进行核对确认。若账单无误，请联系财务付款账单。
                    </div>
                    <div>本期账单：</div>
                    <div class="flex"><p class="font-bold">应收金额：</p>{{ item.AmountReceivable }}元</div>
                    <div class="flex"><p class="font-bold">已收金额：</p>{{ item.AmountReceivable-item.Arrears }}元</div>
                    <div class="bilil-img" @click="IsCheckBillIsorShowImg(1,item.CheckImgUrl)" v-if="item.CheckImgUrl !== ''">
                        <img  class="view-img" :src="downloadUrl+item.CheckImgUrl"/>
                    </div>
                </div>
            </el-tab-pane>
        </el-tabs>
        <div class="tips1" v-else>
            <span>暂无数据</span>
        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {
            downloadUrl: this.$util.QN_URL_BASE,
            dataList: [],
            loading:false,
        };
    },
    mounted() {
        this.getBillsList();
    },
    methods: {
        getBillsList() {
            this.loading = true;
            this.$util
                .axiosGet({
                    url: `/api/IFS/GetBillsList`,
                    hideLoading: true
                })
                .then(res => {
                    if (res.errcode == 0) {
                        this.dataList = res.data;
                        if(this.dataList.length >= 1)
                            this.sendHaveRead(this.dataList[0],0)
                    }
                })
                .catch(() => { })
                .finally(() => {
                    this.loading = false;
                });
        },
        sendHaveRead(data,index) {
            if(data.IsCheck){
                return;
            }
            var i = index;
            this.loading = true;
            this.$util
                .axiosGet({
                    url: `/api/IFS/SendHaveRead?Id=`+data.Id,
                    hideLoading: true
                })
                .then(() => {
                    this.dataList[i].IsCheck = true;
                    console.log(this.dataList)
                    var index = this.dataList.findIndex(i=> i.IsCheck == false);
                    if(index < 0)
                        this.IsCheckBillIsorShowImg(0,false)
                })
                .catch(() => { })
                .finally(() => {
                    this.loading = false;
                });
        },
        showImg(data){
            if(data === ''){
                return;
            }else{
                window.open(this.downloadUrl+data)
            }
        },
        IsCheckBillIsorShowImg(type,data){
            var parems = {};
            if(type == 0){
                parems={
                    type:0,
                    data:data,
                }
                this.$emit('IsCheckBillIs',parems);
            }else{
                parems={
                    type:1,
                    data:this.downloadUrl+data,
                }
                this.$emit('IsCheckBillIs',parems);
            }
        },
    }
};
</script>
<style lang="less">
.dp-body{
    height: 400px;
    border-left: 1px solid #ebeef5;
    border-right: 1px solid #ebeef5;
    border-bottom: 1px solid #ebeef5;
}
.tips1{
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 20px;
    height: 100%;
}
.item-body{
    padding: 12px;
}
.tab-font{
    font-size: 17px;
}
.titiol{
    margin: 10px 0 10px 0;
}
.el-tabs__nav{
    height: 40px;
    text-align: center;
}
.el-tabs__nav-scroll{
    border-right: 1px solid #ebeef5; 

}
.el-tabs--left.el-tabs--card .el-tabs__nav{
    border-bottom:none;
}
.font-bold{
    font-weight: bold;
}
.bilil-img{
    max-height: 240px;margin-top: 10px;
}
.view-img{
    max-width: 180px;
    max-height: 200px;
}
.el-tabs--left.el-tabs--card .el-tabs__nav{
    border: none;
}
.el-tabs__item.is-active{
    background-color: #e4e7ed;
}
</style>
